import { Component, Input, SimpleChanges } from '@angular/core';
import { format } from 'date-fns';
import { Hours } from 'src/app/services/analyse/analyse.types';
import { hasChanged } from 'src/app/utils/change-utils';
import { nb } from 'date-fns/locale';

@Component({
  selector: 'app-daymax-table',
  templateUrl: './daymax-table.component.html',
  styleUrls: ['./daymax-table.component.scss']
})
export class DaymaxTableComponent {
  @Input() dayMaxes: Hours[];
  @Input() highThree: Hours[] | undefined;

  ngOnChanges(changes: SimpleChanges) {
    if (hasChanged([changes.dayMaxes])) {
      this.dayMaxes = changes.dayMaxes?.currentValue;
    }
  }

  formatDate(period: string) {
    const dateString = period.toString().substring(0, 8); // format: YYYYMMDDHH
    const date = new Date(
      parseInt(dateString.substring(0, 4)),
      parseInt(dateString.substring(4, 6)) - 1,
      parseInt(dateString.substring(6, 8))
    );
    return format(date, 'EEEE d.MMM', {
      locale: nb
    }).slice(0, -1);
  }

  formatTime(period: string) {
    const time = Number(period.toString().substring(8, 10)); // format: YYYYMMDDHH
    return (
      (time - 1).toString().padStart(2, '0') +
      ':00' +
      ' – ' +
      time.toString().padStart(2, '0') +
      ':00'
    );
  }

  isHighThree(value: number) {
    if (!this.highThree) return false;
    return this.highThree?.some((hour) => hour.kwh === value);
  }
}
